import { MultiLingualText } from '~/components/atoms';
import { LegendItemStyled, LegendLabelStyled, LegendValueStyled } from './styled';

interface LegendTileProps {
  value: number;
  label: string;
  selected?: boolean;
  clickHandler?: () => void;
}
export const LegendTile: React.FC<LegendTileProps> = ({ value, label, selected = false, clickHandler = () => {} }) => {
  return (
    <LegendItemStyled selected={selected} onClick={clickHandler}>
      <LegendValueStyled>{value}</LegendValueStyled>
      <LegendLabelStyled>
        <MultiLingualText>{label}</MultiLingualText>
      </LegendLabelStyled>
    </LegendItemStyled>
  );
};
